<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <LinkVehicleAndAreaGenerateEventsForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import LinkVehicleAndAreaGenerateEventsForm from "@/components/settings/arena/link-vehicle-and-area-generate-events/LinkVehicleAndAreaGenerateEventsForm";
import LoadingPage from "@/components/spinner/LoadingPage";

export default {
  name: "LinkVehicleAndAreaGenerateEvents",
  components: {
    PageTitle,
    PageRowWrapper,
    LinkVehicleAndAreaGenerateEventsForm,
    LoadingPage,
  },
};
</script>
